import modalStyle from "./modal.module.scss";

import React, { useState, useEffect, memo } from 'react';
import { Typography, Button } from "@mui/material";

const ModalAdoptionHint = (props) => {
  const { title, content, closeOpenModal } = props;

  // State

  // Method

  // Side effect
  useEffect(() => {
  }, []);

  return (
    <>
      <div className={modalStyle['modal_Block']} style={{ margin: '20px 0' }}>
        <Typography color="#707ca8" fontWeight="600" fontSize="20px">
          {title}
        </Typography>
      </div>
      <div className={modalStyle['modal_Block']} style={{ margin: '20px 0' }}>
        <Typography fontSize="15px" color="rgba(0, 0, 0, 0.8)">
          {content}
        </Typography>
      </div >
      <div className={modalStyle['modal_operation']}>
        <Button
          className={modalStyle['modal_saveBtn']}
          style={{ width: '195px', height: '42px', fontSize: '16px' }}
          variant="contained"
          onClick={closeOpenModal}
        >
          Close
        </Button>
      </div>
    </>
  );
}

export default memo(ModalAdoptionHint);